module.exports = __webpack_public_path__ + "img/symbol_6.c4bd2bd5.png";